<app-entity-complaints [entityType]="sharedService.manufacturer"></app-entity-complaints>
